const LINKS: Array<[string, string]> = [
  ['Repository', 'https://github.com/FutureMoney/fargate-deployer'],
  ['Manifest reference', 'https://github.com/FutureMoney/fargate-deployer/blob/main/docs/manifest-reference.md'],
  ['AWS setup', 'https://github.com/FutureMoney/fargate-deployer/blob/main/docs/aws-setup.md'],
  ['Scheduled tasks', 'https://github.com/FutureMoney/fargate-deployer/blob/main/docs/scheduled-tasks.md'],
  ['Architecture', 'https://github.com/FutureMoney/fargate-deployer/blob/main/docs/architecture.md'],
  ['Troubleshooting', 'https://github.com/FutureMoney/fargate-deployer/blob/main/docs/troubleshooting.md'],
  ['Changelog', 'https://github.com/FutureMoney/fargate-deployer/blob/main/CHANGELOG.md'],
  ['npm', 'https://www.npmjs.com/package/fargate-deployer'],
  ['Marketplace', 'https://github.com/marketplace/actions/fargate-deployer'],
];

export function Footer() {
  return (
    <footer>
      <div className="footer-links">
        {LINKS.map(([label, href]) => (
          <a key={href} href={href}>
            {label}
          </a>
        ))}
      </div>
      <p style={{ margin: 0 }}>
        MIT licensed. Not affiliated with Amazon Web Services — “Fargate” and “ECS” are trademarks
        of Amazon.com, Inc.
      </p>
    </footer>
  );
}
